import gql from 'graphql-tag';

export const GroupedReactionsDetails = gql`
  fragment GroupedReactionsDetails on GroupedAccountFileReaction {
    id
    photo {
      id
    }
    video {
      id
    }
    system_sticker {
      id
      is_active
      asset_image {
        id
        url
      }
    }
    reactions_count
    has_account_reaction
  }
`;

export const AccountFileReactionDetails = gql`
  fragment AccountFileReactionDetails on AccountFileReaction {
    id
    photo {
      id
    }
    video {
      id
    }
    system_sticker {
      id
      asset_image {
        id
        url
      }
    }
  }
`;

export const ReactionAccountDetails = gql`
  fragment ReactionAccountDetails on AccountFileReactionAccount {
    account_profile {
      id
      name
      username
      avatar_photo {
        id
        thumbnail_urls {
          url
          size_code
          width
          height
        }
      }
      friend_status {
        is_friend
      }
    }
    system_sticker {
      id
      asset_image {
        id
        url
      }
    }
  }
`;
